import { AddBox, Close, Delete, Edit } from "@mui/icons-material";
import {
  Box,
  Button,
  Fade,
  IconButton,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AddNewTdsTcsRow from "./AddNewTdsTcsRow";
import Loader from "../../Components/Loader";
import DeleteTcsTds from "./DeleteTcsTds";
import { useGetCompanyCodeTranslationQuery } from "../../../../redux/apis/getCompanyCodeTranslation.api";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  // p: 4,
  outline: "none",
  width: { xs: "90%", lg: 1200 },
  height: "500px",
};
function AddTdsTcsOptions({
  open,
  setOpen,
  optionType,
  setOptionType,
  Type,
  setData,
  getAccountData,
  setDataTDS,
  data,
  totTaxAmt = 0,
}) {
  console.log(data, "data");
  const header = [
    {
      id: "ID",
      label: "ID",
      width: 100,
      align: "left",

      required: "",
    },
    {
      id: "CodeText",
      label:
        optionType === "Add New TDS Option" ? "TDS Section" : "TCS Section",

      width: 100,
      align: "left",

      required: "",
    },
    {
      id: "CodePercentage",
      label:
        optionType === "Add New TDS Option"
          ? "TDS Percentage (%)"
          : "TCS Percentage (%)",
      width: 300,
      align: "left",

      required: "",
    },

    {
      id: "action",
      label: "Action",
      width: 100,
      align: "center",
      required: "",
    },
  ];
  const [rows, setRows] = useState([
    {
      index: "",
      codeText: "",
      codeOrder: "",
      codePercentage: "",
      codeID: "",
      new: true,
      editable: false,
    },
  ]);
  const [editedRows, setEditedRows] = useState({
    index: "",
    codeText: "",
    codeOrder: "",
    codePercentage: "",
    codeID: "",
    new: true,
    editable: false,
  });
  const [tempRows, setTempRows] = useState({
    index: "",
    codeText: "",
    codeOrder: "",
    codePercentage: "",
    codeID: "",
    new: true,
    editable: false,
  });
  const [backdropOpen, setBackdropOpen] = useState(false);
  const newPriceObj = {
    index: "",
    codeText: "",
    codeOrder: "",
    codePercentage: "",
    codeID: "",
    new: true,
    editable: false,
  };
  const labelNames = {
    tdsOrTcsType: optionType === "Add New TDS Option" ? "1" : "2",
    amountName: "Invoice Amount",
    tcsOrTdsName:
      optionType === "Add New TDS Option" ? "Add TDS if any" : "Add TCS if any",
    tcsOrTdsLabel:
      optionType === "Add New TDS Option" ? "TDS Section" : "TDS Section",
    tcsOrTdsAmountLabel:
      optionType === "Add New TDS Option" ? "TDS (%)" : "TCS (%)",
    amountAfterLabel:
      optionType === "Add New TDS Option"
        ? "Amount(After TDS)"
        : "Amount(After TCS)",
  };

  const [addEvent, setAddEvent] = useState(false);
  const [tdsTcsID, setTdsTcsID] = useState("");
  const [deletePriceType, setDeletePriceType] = useState(false);
  const handleClose = () => {
    setTdsTcsID("");
    if (setOptionType) {
      setOptionType("");
    }
    setAddEvent(false);
    setOpen(false);
  };
  const {
    data: tcsList,
    isLoading: isTcsListLoading,
    isError: isTcsListError,
    // refetch
  } = useGetCompanyCodeTranslationQuery({ codetype: labelNames?.tdsOrTcsType });
  const {
    data: tdsList,
    isLoading: isTdsListLoading,
    isError: isTdsListError,
    // refetch
  } = useGetCompanyCodeTranslationQuery({ codetype: labelNames?.tdsOrTcsType });

  async function listTdsTcsDetails() {
    if (optionType === "Add New TDS Option") {
      getTdsSection();
    } else {
      getTcsSection();
    }
  }
  async function getTcsSection() {
    // const res = await API.graphql(
    //   graphqlOperation(getCompanyCodeTranslation, {
    //     codetype: labelNames?.tdsOrTcsType,
    //   })
    // );
    let optionArr = [];
    let optionObj = {};
    if (tcsList !== null) {
      setBackdropOpen(true);
      let sectionArrays = tcsList.map((element) => {
        optionObj = {
          codeText: element.codetext,
          codeOrder: element.codeorder,
          codePercentage: element.codevalue,
          companyID: element.companyid,
          codeID: element?.id,
          new: false,
          editable: false,
        };
        optionArr.push(optionObj);
        return {
          option: `${element.codetext} (${element.codevalue}%)`,
          value: `${element.codevalue}`,
          section: element.codeorder,
        };
      });

      setRows(optionArr);
      setEditedRows(newPriceObj);
      setTempRows(newPriceObj);
      setBackdropOpen(false);
    }
  }
  async function getTdsSection() {
    // const res = await API.graphql(
    //   graphqlOperation(getCompanyCodeTranslation, {
    //     codetype: labelNames?.tdsOrTcsType,
    //   })
    // );
    let optionArr = [];
    let optionObj = {};
    if (tdsList !== null) {
      setBackdropOpen(true);
      let sectionArrays = tdsList.map((element) => {
        optionObj = {
          codeText: element.codetext,
          codeOrder: element.codeorder,
          codePercentage: element.codevalue,
          companyID: element?.companyid,
          codeID: element?.id,
          new: false,
          editable: false,
        };
        optionArr.push(optionObj);
        return {
          option: `${element.codetext} (${element.codevalue}%)`,
          value: `${element.codevalue}`,
          section: element.codeorder,
        };
      });

      setRows(optionArr);
      setEditedRows(newPriceObj);
      setTempRows(newPriceObj);
      setBackdropOpen(false);
    }
  }
  useEffect(() => {
    listTdsTcsDetails();
  }, [optionType, tcsList, tdsList]);
  useEffect(() => {
    let elements = document.getElementById("codeText");
    elements?.focus();
  }, [rows, addEvent]);
  return (
    <Box id={open?"AddTdsTcsOptions":""}>
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
      BackdropProps={{
        timeout: 500,
      }}
      onClose={handleClose}
      // sx={{zIndex:5500}}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Box
            sx={{
              backgroundColor: "primary.main",
              padding: "5px 15px",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: "#fff",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {optionType}
                <IconButton aria-label="delete" onClick={handleClose}>
                  <Close sx={{ color: "#fff" }} />
                </IconButton>
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              backgroundColor: "white",
              padding: "15px",
            }}
          >
            <TableContainer
              sx={{
                ".MuiTableContainer-root": {
                  overflowY: "scroll",
                  // width: 1000,
                },

                height: 400,
                "&::-webkit-scrollbar": {
                  width: "0.4em",
                  height: "0.4em",
                },
              }}
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow sx={{ height: 10 }}>
                    {header.map((column) => {
                      return (
                        <TableCell
                          key={column.id}
                          minWidth={column.minWidth}
                          align={column.align}
                          sx={{
                            fontWeight: 600,
                            fontSize: "14px",
                            color: "input.label",
                            backgroundColor: "background.tablebg",
                          }}
                        >
                          {column.label}{" "}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {addEvent === true && (
                    <AddNewTdsTcsRow
                      rows={rows}
                      setRows={setRows}
                      editedRows={editedRows}
                      setEditedRows={setEditedRows}
                      setAddEvent={setAddEvent}
                      tdsTcsID={tdsTcsID}
                      getAccountData={getAccountData}
                      optionType={optionType}
                      setData={setData}
                      data={data}
                      setDataTDS={setDataTDS}
                      setOpen={setOpen}
                      Type={Type}
                      totTaxAmt={totTaxAmt}
                    />
                  )}
                  {rows.length > 0 ? (
                    <>
                      {rows.map((col, ind) => {
                        if (col.editable && tdsTcsID) {
                          return (
                            <AddNewTdsTcsRow
                              rows={rows}
                              setRows={setRows}
                              editedRows={editedRows}
                              setEditedRows={setEditedRows}
                              setAddEvent={setAddEvent}
                              tdsTcsID={tdsTcsID}
                              optionType={optionType}
                              ind={ind}
                              data={data}
                              setDataTDS={setDataTDS}
                              Type={Type}
                              totTaxAmt={totTaxAmt}
                              setData={setData}
                              setOpen={setOpen}
                            />
                          );
                        } else {
                          return (
                            <TableRow  
                             className="noTableCellBorder"
                              sx={{
                                height: "40px",
                                ".MuiTableCell-root": {
                                  // backgroundColor: "transparent !important",
                                  color: "black",
                                },
                              }}
                            >
                              <TableCell>
                                {/* {col.Id} */}
                                {ind + 1}
                              </TableCell>
                              <TableCell>{col.codeText}</TableCell>
                              {/* <TableCell>{col.codeOrder}</TableCell> */}
                              <TableCell>{col.codePercentage}</TableCell>
                              <TableCell align="center" sx={{ width: 80 }}>
                                {col.companyID !== 0 && (
                                  <>
                                    <Tooltip
                                      title={"Edit"}
                                      placement="right"
                                      disableInteractive
                                      arrow
                                    >
                                      <IconButton
                                        aria-label="delete"
                                        sx={{
                                          margin: "0px 2px",
                                          padding: "5px",
                                          backgroundColor: "#D0EFFF",
                                        }}
                                        onClick={() => {
                                          setAddEvent(false);

                                          setEditedRows(col);
                                          setTdsTcsID(col.codeID);

                                          let arr = [...rows];
                                          let tempArr = arr.filter(
                                            (ele, index) => {
                                              if (ele.new !== true) {
                                                if (ele.codeID == col.codeID) {
                                                  ele.editable = true;
                                                  ele.new = false;
                                                } else {
                                                  ele.editable = false;
                                                  ele.new = false;
                                                }
                                                return ele;
                                              }
                                            }
                                          );
                                          setRows(tempArr);
                                        }}
                                      >
                                        <Edit
                                          sx={{
                                            fontSize: "15px",
                                            color: "#6096d9",
                                          }}
                                        />
                                      </IconButton>
                                    </Tooltip>

                                    <Tooltip
                                      title={"Delete"}
                                      placement="right"
                                      disableInteractive
                                      arrow
                                    >
                                      <IconButton
                                        disableRipple
                                        onClick={(event) => {
                                          setDeletePriceType(true);
                                          setTdsTcsID(col.codeID);
                                          setEditedRows(col);
                                        }}
                                        aria-label="delete"
                                        sx={{
                                          margin: "0px 2px",
                                          padding: "5px",
                                          backgroundColor: "#fbc7c7",
                                        }}
                                      >
                                        <Delete
                                          sx={{
                                            fontSize: "15px",
                                            color: "#eb6a6a",
                                          }}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  </>
                                )}
                              </TableCell>
                            </TableRow>
                          );
                        }
                      })}
                    </>
                  ) : (
                    <>
                      <TableRow>
                        <TableCell
                          align="center"
                          colSpan={3}
                          sx={{ border: "none", heigt: "40px" }}
                        >
                          No Data Found
                        </TableCell>
                      </TableRow>
                    </>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Box sx={{ dispaly: "flex", justifyContent: "space-between" }}>
                <Button
                  variant="outlined"
                  disableRipple
                  disableElevation
                  size="small"
                  onClick={() => {
                    let element= document?.getElementById("codeText")
                    element?.focus()
                    setAddEvent(true);
                    setTdsTcsID("");
                    setEditedRows(newPriceObj);
                    setTempRows(newPriceObj);
                   
                  }}
                  startIcon={<AddBox />}
                  sx={{
                    fontSize: "12px",
                    marginTop: "15px",
                  }}
                >
                  Add New Line
                </Button>
              </Box>
            </Box>
          </Box>
          <Loader open={backdropOpen} />
          <DeleteTcsTds
            open={deletePriceType}
            setOpen={setDeletePriceType}
            priceTypeID={tdsTcsID}
            setPriceTypeID={setTdsTcsID}
            editedRows={editedRows}
            optionType={optionType}
            getAccountData={getAccountData}
          />
        </Box>
      </Fade>
    </Modal>
    </Box>
  );
}

export default AddTdsTcsOptions;
